import React from 'react';
import GroupLeaderboardRow from './GroupLeaderboardRow';
import EmptyState from '../../../../UI/EmptyState';
import styles from '../../../../../styles/LeaderBoard.module.css';

interface GroupLeaderboardEntry {
  rank: number;
  user: {
    id: string;
    full_name: string;
    email: string;
    avatar?: string;
    first_name?: string;
    last_name?: string;
    designation?: string | null;
  };
  points: number;
  tasks_completed: number;
  participation_score: number;
  quality_score?: number;
  efficiency?: number;
  current_streak?: number;
  badges: string[];
  role?: string;
}

interface GroupLeaderboardTableProps {
  entries: GroupLeaderboardEntry[];
  highlightedRow: number | null;
  onRowHover: (index: number) => void;
  onRowLeave: () => void;
}

const GroupLeaderboardTable: React.FC<GroupLeaderboardTableProps> = ({
  entries,
  highlightedRow,
  onRowHover,
  onRowLeave
}) => {
  if (entries.length === 0) {
    return (
      <EmptyState
        icon={
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="currentColor"/>
            <path d="M12 7C11.45 7 11 7.45 11 8V13C11 13.55 11.45 14 12 14C12.55 14 13 13.55 13 13V8C13 7.45 12.55 7 12 7ZM11 15H13V17H11V15Z" fill="currentColor"/>
          </svg>
        }
        title="No leaderboard data"
        description="No entries found for the selected filters. Try adjusting your filters to see more results."
      />
    );
  }

  return (
    <div className={styles.leaderboardTableContainer}>
      <table className={styles.leaderboardTable}>
        <thead>
          <tr>
            <th className={styles.rankColumn}>Rank</th>
            <th className={styles.memberColumn}>Member</th>
            <th className={styles.pointsColumn}>Points</th>
            <th className={styles.tasksColumn}>Tasks</th>
            <th className={styles.qualityColumn}>Quality</th>
            <th className={styles.actionsColumn}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {entries.map((entry, index) => (
            <GroupLeaderboardRow
              key={entry.user.id}
              entry={entry}
              index={index}
              isHighlighted={highlightedRow === index}
              onMouseEnter={() => onRowHover(index)}
              onMouseLeave={onRowLeave}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default GroupLeaderboardTable;

